// extracted by mini-css-extract-plugin
export default {"PageBackBtn":"AddCustomRole_PageBackBtn__Mz-Xq","PageBackBtnWrap":"AddCustomRole_PageBackBtnWrap__NvC4o","roleHead":"AddCustomRole_roleHead__iUJB+"};